export default __webpack_public_path__ + "static/SanFranciscoText-Medium-6099e3d89f02065eef607046da22b2bb.eot";